import React from "react";
import founderImage from "../../assets/Homepage/DrImage.png";
import founderImageMobile from "../../assets/Homepage/DrMobile.png";
import arrow from "../../assets/Homepage/Buttonarrow.svg";
import RoundedArrowButton from "../../components/RoundedArrowButton";

const FounderSection = () => {
  return (
    <section className="bg-white py-16 md:py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          {/* Text Content (Left Side on desktop, always first in DOM) */}
          <div className="md:w-1/2 order-1 md:order-none pr-2">
            <h2 className="font-garamond-subheading  md:text-[70px] text-[32px] font-normal text-[#2C3075] leading-tight">
              Meet Our Founder – Dr. Ketan Vaidya
            </h2>

            <p className="font-generalsans-description pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] tracking-[0]tracking-normal  text-[14px]">
              With over 19 years of experience in psychiatry, Dr. Ketan Vaidya
              has dedicated his career to helping individuals overcome mental
              health challenges and addiction. His compassionate approach,
              combined with expertise in holistic recovery, has transformed
              countless lives. Through Arambh Rehab, he aims to provide a safe,
              supportive, and empowering environment where healing begins and
              hope is restored.
            </p>

            {/* <button className="bg-blue-800 hover:bg-blue-900 text-white font-medium py-3 px-8 rounded-full transition duration-300">
              More about us
            </button> */}

            <div className="items-start my-4">
              {/* "More About Us" Button */}
                            <RoundedArrowButton label="More about Us" to="/aboutus" />

            </div>
          </div>

          {/* Image (Right Side on desktop, Top on mobile) */}
          <div className="md:w-1/2  order-0 md:order-none">
            {/* Desktop Image */}
            <img
              src={founderImage}
              alt="Dr. Ketan Vaidya"
              className="hidden md:block w-full h-auto rounded-lg shadow-lg object-cover"
            />
            {/* Mobile Image (optional: use same image or different cropped version) */}
            <img
              src={founderImageMobile || founderImage} // Fallback to same image if mobile version not available
              alt="Dr. Ketan Vaidya"
              className="md:hidden w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
